const MENU_EN = Object.freeze({
  'main-menu.contact-us': 'Contact Us',
  'main-menu.faq': 'FAQ',
  'main-menu.home': 'Home',
  'main-menu.logout': 'Logout',
  'main-menu.contact-us.phone': 'Phone',
  'main-menu.contact-us.email': 'Qiao Yi Dai Enquiry Email',
  'main-menu.contact-us.quantumEmail': 'Quantum Enquiry Email',
  'main-menu.contact-us.wechat': 'WeChat ID',
});

export { MENU_EN };
